module.exports = __webpack_public_path__ + "img/step1.9afb9573.png";